import React from 'react';
import Select from 'react-select';
import { isMobile } from 'react-device-detect';


/* a custom options component for WrappedSelect Component */
class CustomOptions extends React.Component {
  constructor(props){
    super(props);
  }
  handleMouseDown (event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  }
  handleMouseEnter (event) {
    this.props.onFocus(this.props.option, event);
  }
  handleMouseMove (event) {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  }
  render(){
    return (
      <div key={this.props.option.value}
      className={"optLabel " + this.props.className}
      onMouseDown={this.handleMouseDown.bind(this)}
      onMouseEnter={this.handleMouseEnter.bind(this)}
      onMouseMove={this.handleMouseMove.bind(this)}>
        <div className="labelText">{this.props.option.label}</div>
        <div className="detailText">{this.props.option.details}</div>
      </div>
    );
  }
}

// a wrapper class for react-select's Select component which doesnt keep its own selected state
export default class WrappedSelect extends React.Component {
  constructor (props){
    super(props);
    this.state = {
      value: this.formatValueFromAPI(this.props.value),
      myActiveElementType: props.activeElementType,
    };
  }

  formatValueForAPI(value){
    if(this.props.multi){
      let newValues = {};
      for(let i=0; i<value.length; i++){
        let selection = value[i];
        newValues[selection.value] = true;
      }
      return newValues;
    } else{
      return value ? value.value : null;
    }
  }
  formatValueFromAPI(value){
    if(this.props.multi){
      let newValues = [];
      for (let key in value) {
        if (value.hasOwnProperty(key)) {
          /* Because we're looking through the keys of the Objects, these are all
          ** string keys, meaning that when matched against the Int value of an option
          ** this will result in a mismatch (e.g. 12345 !== "12345").*/
          newValues.push(isNaN(parseInt(key)) ? key : parseInt(key));
        }
      }
      return newValues;
    } else{
      return value;
    }
  }
  updateValue(newValue){
    this.props.onChange(this.formatValueForAPI(newValue));
    this.setState({value: newValue});
    if (newValue.value === "other") {
      this.setState({ myActiveElementType: "input" });
    }
  }
  handleTextChange(e){
      let newValue = {
         value: e.target.value,
        label: this.state.value.label,
      }
      this.props.onChange(this.formatValueForAPI(newValue));
      this.setState({value: newValue});
  }

  cancelTextInput(){
      this.props.onChange(this.formatValueForAPI(this.props.options[0]));
      this.setState({value: this.props.options[0]});
      this.setState({myActiveElementType: "dropdown" });
  }

  dropdownComponent() {
    return (
      <Select
        multi={this.props.multi}
        name={this.props.name}
        value={this.state.value}
        optionComponent={CustomOptions}
        inputProps={this.props.autocomplete ? {autoComplete: "on"} : {autoComplete: "none"}}
        options={this.props.options}
        onChange={this.updateValue.bind(this)}
        className={this.props.className}
        searchable={isMobile ? false : true}
        style={this.props.size ? {maxWidth: `${this.props.size}px`} : {}}
      />
      );
    }

    inputComponent() {
      return (
        <div className="inline-input-group">
          <input
            type="text"
            key={"input"+this.props.name}
            name={this.props.name}
            id={this.props.name}
            size={this.props.size}
            maxLength={this.props.max}
            className="default-input"
            defaultValue={this.props.value}
            autoComplete={this.props.autocomplete ? "on" : "off"}
            onChange={this.handleTextChange.bind(this)}
            style={{display: 'inline-block'}}

          />
          <span 
            onClick={this.cancelTextInput.bind(this)} 
            style={{margin: '0 10px 0 -20px'}}
           >
            &nbsp;x&nbsp;
          </span>
        </div>
      );
    }

  render(){
    return(
      <div>
      {!this.props.multi && this.state.myActiveElementType === "input" ? this.inputComponent() : this.dropdownComponent()}     
      </div>
    );
  }
}

  WrappedSelect.defaultProps = {
    activeElementType: 'dropdown',
  }




// WEBPACK FOOTER //
// ./src/components/Common/WrappedSelect.js